import { render, staticRenderFns } from "./VideoHeader.vue?vue&type=template&id=d83c0b6e&"
import script from "./VideoHeader.vue?vue&type=script&lang=js&"
export * from "./VideoHeader.vue?vue&type=script&lang=js&"
import style0 from "./VideoHeader.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports